export const EMOJI_SETS = [
  {
    id: "mammals",
    name: "Farm Mammals",
    emojis: {
      p: "🐇",
      n: "🐎",
      b: "🐐",
      r: "🐑",
      q: "🐄",
      k: "🐖",
      x: "🥚",
    },
  },
  {
    id: "monkeys",
    name: "Monkeys/Apes",
    emojis: {
      p: "🍌",
      n: "🐒",
      b: "🙈",
      r: "🙉",
      q: "🦧",
      k: "🦍",
      x: "🥜",
    },
  },
  {
    id: "dogs",
    name: "Dogs",
    emojis: {
      p: "🦴",
      n: "🐕‍🦺",
      b: "🐩",
      r: "🐕",
      q: "🦊",
      k: "🐺",
      x: "🐣",
    },
  },
  {
    id: "felines",
    name: "Felines",
    emojis: {
      p: "🐱",
      n: "🐆",
      b: "🐅",
      r: "🐈",
      q: "🐯",
      k: "🦁",
      x: "🐾",
    },
  },
  {
    id: "structures",
    name: "Structures",
    emojis: {
      p: "🏠",
      n: "🏨",
      b: "⛪",
      r: "🏩",
      q: "🏦",
      k: "🏰",
      x: "🏗️",
    },
  },
  {
    id: "plants",
    name: "Plants",
    emojis: {
      p: "🌱",
      n: "🥀",
      b: "🌷",
      r: "🌼",
      q: "🌹",
      k: "🌻",
      x: "🌰",
    },
  },
  {
    id: "insects",
    name: "Insects",
    emojis: {
      p: "🐜",
      n: "🐛",
      b: "🐞",
      r: "🐌",
      q: "🐝",
      k: "🦋",
      x: "🥚",
    },
  },
  {
    id: "digital",
    name: "Digital",
    emojis: {
      p: "🔋",
      n: "📡",
      b: "📷",
      r: "📹",
      q: "📱",
      k: "💻",
      x: "⚙️",
    },
  },
  {
    id: "analog",
    name: "Analog",
    emojis: {
      p: "📄",
      n: "📚",
      b: "📕",
      r: "✏️",
      q: "✒️",
      k: "📔",
      x: "📝",
    },
  },
  {
    id: "sweet",
    name: "Sweet",
    emojis: {
      p: "🍪",
      n: "🎠",
      b: "🍭",
      r: "🍩",
      q: "🍫",
      k: "🎂",
      x: "🍯",
    },
  },
  {
    id: "salty",
    name: "Salty",
    emojis: {
      p: "🌮",
      n: "🍟",
      b: "🌭",
      r: "🍕",
      q: "🌯",
      k: "🍔",
      x: "🧂",
    },
  },
  {
    id: "sushi",
    name: "Sushi",
    emojis: {
      p: "🍚",
      n: "🍤",
      b: "🍣",
      r: "🍥",
      q: "🦀",
      k: "🍱",
      x: "🦪",
    },
  },
  {
    id: "fish",
    name: "Fish",
    emojis: {
      p: "🐟",
      n: "🦐",
      b: "🐠",
      r: "🐡",
      q: "🐬",
      k: "🦈",
      x: "🥚",
    },
  },
  {
    id: "harry_potter",
    name: "Harry Potter",
    emojis: {
      p: "🦉",
      n: "🧹",
      b: "🧙‍♂️",
      r: "🏰",
      q: "✨",
      k: "⚡",
      x: "🔮",
    },
  },
  {
    id: "mario_bros",
    name: "Mario Bros",
    emojis: {
      p: "🍄",
      n: "⭐",
      b: "🐢",
      r: "🏰",
      q: "👸",
      k: "👨‍🔧",
      x: "❓",
    },
  },
  {
    id: "medieval",
    name: "Medieval Set",
    emojis: {
      p: "🛡️",
      n: "🐎",
      b: "🧙‍♂️",
      r: "🏰",
      q: "👸",
      k: "🤴",
      x: "⚔️",
    },
  },
  {
    id: "christmas",
    name: "Christmas",
    emojis: {
      p: "🎁",
      n: "🦌",
      b: "🎄",
      r: "⛄",
      q: "🤶",
      k: "🎅",
      x: "🎀",
    },
  },
  {
    id: "ocean",
    name: "Ocean Set",
    emojis: {
      p: "🌊",
      n: "🦭",
      b: "🦞",
      r: "🐙",
      q: "🐬",
      k: "🐋",
      x: "🫧",
    },
  },
  {
    id: "halloween",
    name: "Halloween Set",
    emojis: {
      p: "🎃",
      n: "🦇",
      b: "🧛‍♂️",
      r: "🧟‍♀️",
      q: "🧙‍♀️",
      k: "👻",
      x: "🕸️",
    },
  },
  {
    id: "space",
    name: "Space Set",
    emojis: {
      p: "🪐",
      n: "🛰️",
      b: "🌕",
      r: "👽",
      q: "🛸",
      k: "🚀",
      x: "⭐",
    },
  },
  {
    id: "sports",
    name: "Sports Set",
    emojis: {
      p: "⚽",
      n: "⛳",
      b: "🏈",
      r: "🥅",
      q: "🏀",
      k: "🏆",
      x: "🥇",
    },
  },
  {
    id: "music",
    name: "Music Set",
    emojis: {
      p: "🎵",
      n: "🎤",
      b: "🎧",
      r: "🎷",
      q: "🎸",
      k: "🎻",
      x: "🎶",
    },
  },
  {
    id: "circus",
    name: "Circus Set",
    emojis: {
      p: "🎟️",
      n: "🎪",
      b: "🎭",
      r: "🤡",
      q: "🤹‍♀️",
      k: "🐘",
      x: "🎠",
    },
  },
  {
    id: "weather",
    name: "Weather Set",
    emojis: {
      p: "☁️",
      n: "🌪️",
      b: "🌧️",
      r: "⚡",
      q: "🌈",
      k: "🌞",
      x: "❄️",
    },
  },
  {
    id: "mythical",
    name: "Mythical Creatures",
    emojis: {
      p: "🧚",
      n: "🦄",
      b: "🧜",
      r: "👹",
      q: "🧞",
      k: "🐉",
      x: "✨",
    },
  },
  {
    id: "weapons",
    name: "Weapons",
    emojis: {
      p: "🔪",
      n: "🛡️",
      b: "🏹",
      r: "⚔️",
      q: "💣",
      k: "☢️",
      x: "🔥",
    },
  },
].map((set, index) => ({ ...set, difficulty: index + 1 }));

